import React from 'react';

import { useNavigation } from '../ScreensContext';
import NavigationMenu from './NavigationMenu';
import { useNavigationWithExternalLinks } from './hooks';

export const Navigation = ({
  favorites,
  onChangeFavorites,
  columnCount,
  withFavorite,
  searchQuery,
  onClose,
  externalLinks,
}) => {
  const navigation = useNavigation();

  const navigationWithExternalLinks = useNavigationWithExternalLinks({
    navigation,
    externalLinks,
  });

  return (
    <NavigationMenu
      onClose={onClose}
      searchQuery={searchQuery}
      navigation={navigationWithExternalLinks}
      favoriteIds={favorites}
      onChangeFavorites={onChangeFavorites}
      columnCount={columnCount}
      withFavorite={withFavorite}
    />
  );
};
